import { Card, Text, Link } from '@servicetitan/design-system';
import { Icon } from 'semantic-ui-react';
import * as Styles from './saved-payment-info-card.module.less';
import { ACHModal } from './ach-modal';
import { BankAccountModel } from '../api/internal-billing.api';
import { provide } from '@servicetitan/react-ioc';
import { AchModalStore, PlaidIntegrations } from '..';

interface Props {
    accountNumber?: string;
    isCreditCard: boolean;
    bankName?: string;
    bankLogoPath?: string | null;
    onComplete?(bankDetails: BankAccountModel): void;
    actionHandler?(): void;
    className?: string;
    cardOnly?: boolean;
}

export const SavedPaymentInfoCard = provide({ singletons: [AchModalStore, PlaidIntegrations] })(
    (props: Props) => (
        <div>
            <Text headline size={3}>
                {!props.cardOnly && (props.isCreditCard ? 'Credit Card' : 'Bank Account')}
            </Text>
            <Card padding="none" className={props.className}>
                <div className={Styles.paymentInfoContainer}>
                    <div className={Styles.bankIconContainer}>
                        {props.bankLogoPath ? (
                            <img
                                src={props.bankLogoPath}
                                alt={props.bankName}
                                title={props.bankName}
                            />
                        ) : (
                            <Icon
                                fitted
                                name={props.isCreditCard ? 'credit card outline' : 'university'}
                                color="grey"
                                size="big"
                            />
                        )}
                    </div>
                    <div className={Styles.accountDetailContainer}>
                        {props.isCreditCard && !props.accountNumber ? (
                            <Link subdued onClick={props.actionHandler}>
                                Add your credit card
                            </Link>
                        ) : (
                            <Text subdued el="div" size={2}>
                                {props.isCreditCard ? props.bankName : 'Account Number:'}
                            </Text>
                        )}
                        {props.accountNumber && (
                            <Text headline el="div" size={3}>
                                {'XXXX' +
                                    (props.accountNumber.length > 4
                                        ? props.accountNumber.substring(
                                              props.accountNumber.length - 4,
                                              props.accountNumber.length
                                          )
                                        : props.accountNumber)}
                            </Text>
                        )}
                    </div>
                    {props.accountNumber && (
                        <div className={Styles.linkContainer}>
                            {props.isCreditCard ? (
                                <Link subdued onClick={props.actionHandler}>
                                    Change
                                </Link>
                            ) : (
                                <ACHModal
                                    onComplete={props.onComplete!}
                                    buttonText="update"
                                    isUpdate
                                />
                            )}
                        </div>
                    )}
                </div>
            </Card>
        </div>
    )
);
